export function contactName(c: { first_name?: string | null; last_name?: string | null; email?: string | null; phone?: string | null }) {
  const name = [c.first_name, c.last_name].filter(Boolean).join(" ");
  return name || c.email || c.phone || "Unnamed contact";
}

const rtf = new Intl.RelativeTimeFormat("en-GB", { numeric: "auto" });

export function ago(iso: string | null | undefined) {
  if (!iso) return "—";
  const diff = (new Date(iso).getTime() - Date.now()) / 1000;
  const abs = Math.abs(diff);
  if (abs < 60) return rtf.format(Math.round(diff), "second");
  if (abs < 3600) return rtf.format(Math.round(diff / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), "hour");
  if (abs < 86400 * 30) return rtf.format(Math.round(diff / 86400), "day");
  return day(iso);
}

// One date style everywhere: "4 Nov 2026" and "4 Nov 2026, 09:30".
const dayFmt = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric" });
const dateTimeFmt = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

/** day writes a date as "4 Nov 2026". */
export function day(iso: string | null | undefined) {
  return iso ? dayFmt.format(new Date(iso)) : "—";
}

/** dateTime writes a moment as "4 Nov 2026, 09:30" (the browser's time zone). */
export function dateTime(iso: string | null | undefined) {
  return iso ? dateTimeFmt.format(new Date(iso)) : "—";
}

export const roleLabel: Record<string, string> = {
  crm_admin: "Admin",
  crm_manager: "Manager",
  crm_employee: "Employee",
  crm_analyst: "Analyst",
};

/** Plain-word names for values stored as codes. */
export const stageLabel: Record<string, string> = { visitor: "Visitor", lead: "Lead", qualified: "Qualified", customer: "Customer", inactive: "Inactive" };
export const stages = ["visitor", "lead", "qualified", "customer", "inactive"] as const;
export const sourceLabel: Record<string, string> = {
  manual: "Added by the team", website_agent: "Website chat", import: "Import", whatsapp: "WhatsApp", booking_page: "Booking page", email: "Email",
};
export const priorityLabel: Record<string, string> = { low: "Low", normal: "Normal", high: "High" };
export const label = (map: Record<string, string>, v: string | null | undefined) => (v ? map[v] ?? v.replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase()) : "—");

/** initials: "Maryam Al Hashimi" → "MA". */
export function initials(name: string) {
  const parts = name.replace(/[^\p{L}\p{N} ]/gu, " ").trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? "?") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}
